import * as React from 'react';
import b_ from 'b_';

import './index.scss';

const b = b_.with('stock-top-card-property');

interface Props {
  title: string;
}

export const Property: React.SFC<Props> = ({ title, children }) => (
  <div className={b()}>
    <div className={b('title')}>{title}</div>
    <div className={b('value')}>{children}</div>
  </div>
);
